/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2021 ${ORGANIZATION}.
 * @license    __LICENSE__
 */

import '@main';

$(() => {
  const modal = $('#spec-modal');
  const input = $('.c-spec-modal__input');
  const wrapper = $('.c-spec-modal__wrapper');
  let timer = 0;

  modal.on('show.bs.modal', function () {
    getCompares();
  });

  modal.on('hide.bs.modal', function () {
    input.val('');
  });

  input.on('input', function () {
    let key = $(this).val();

    clearTimeout(timer);
    timer = setTimeout(function () {
      getCompares(key);
    }, 500);
  });

  function getCompares(q) {
    let data = u.data('item');
    let models = u.data('models');
    let categoryId = u.data('categoryId');
    let key = q ? q : '';

    const router = u.route('compare_get_list', { task: 'getCompareList', q: key, category_id: categoryId, models });

    u.$http.get(router)
      .then(function (response) {
        wrapper.html(response.data.data);
      }).catch(function (xhr) {
        console.log(xhr);
      });
  }

  // Nav
  u.$ui.loadAlpine(() => {
    Alpine.data('compareNav', () => {
      return {
        open: true,

        init() {
          const $nav = $(this.$el);
          const $win = $(window);

          $win.on('scroll', toggleNav);
          toggleNav();

          function toggleNav() {
            if ($win.scrollTop() > 800) {
              $nav.fadeIn();
            } else {
              $nav.fadeOut();
            }
          }
        },

        linkClick(e) {
          const $link = $(e.currentTarget);
          e.preventDefault();

          const [href] = location.href.split('#');
          const $target = $($link.attr('href'));

          history.pushState({}, '', href + $link.attr('href'));

          $('html, body').animate({ scrollTop: $target.offset().top - 130 });
        },

        toggleNav() {
          this.open = !this.open;
        }
      }
    });
  });
});
